// oficio-instituicao-ensino.component.ts
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  inject,
  booleanAttribute,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { ApiService } from '@core/providers/http/api.service';
import {
  BolseiroService,
  BolsaService,
  InstituicaoEnsinoCursoService,
  InstituicaoEnsinoService,
} from '../../../api/services';
import { Pagination } from '@app/shared/model';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Subject, takeUntil } from 'rxjs';
import { toExtensoComMoeda } from '@app/core/helpers/toExtensoComMoeda';
interface VerificarRegraPagamentoPayload {
  id: string; // "0"
  pedidoID: number; // ex.: 0
  bolseiroID: number; // ex.: 179
  requerenteID: number; // ex.: 0
  isActive: boolean; // ex.: true
  tipoBolsa: number; // ex.: 1
  paisID: number; // ex.: 193
  instituicaoGestoraID: number; // ex.: 3
  nivelAcademico: number; // ex.: 4
  areaProgramaFormacaoID: number; // ex.: 4
  programaFormacaoID: number; // ex.: 5
  anoCurricularFrequencia: string; // ex.: "1"
  valorSubsidio: number; // ex.: 0
}

@Component({
  selector: 'app-oficio-instituicao-ensino',
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    Toast,
    ButtonModule,
    Ripple,
    SelectModule,
    CalendarModule,
    CommonModule,
    TableModule,
    DataVoidComponent,
    NgxMaskPipe,
    NgxMaskDirective,
    ConfirmDialogModule,
  ],
  providers: [
    InstituicaoEnsinoService,
    ApiService,
    BolseiroService,
    BolsaService,
    InstituicaoEnsinoCursoService,
    provideNgxMask(),
    MessageService,
    ConfirmationService,
  ],
  templateUrl: './oficio-instituicao-ensino.component.html',
  styleUrl: './oficio-instituicao-ensino.component.scss',
})
export class OficioInstituicaoEnsinoComponent
  implements OnInit, OnChanges, OnDestroy
{
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  instituicaoEnsinoCursoService = inject(InstituicaoEnsinoCursoService);
  bolseiroService = inject(BolseiroService);
  bolsaService = inject(BolsaService);
  fb = inject(FormBuilder);

  @Input() documento: any;
  @Input() bolseiroID!: string;
  @Input({ transform: booleanAttribute }) disabled = false;
  @Output() formValueChanges = new EventEmitter<any>();

  pagination: Pagination<any> = new Pagination<any>();
  form: FormGroup;
  students: any[] = [];
  Estudantes: any[] = [];
  InstEnsino: any[] = [];
  instituicaoCursoList: any[] = [];
  AnoCurricar: { label: string; value: string }[] = [];
  bolsa: any;
  valorRegra: number | null = null;
  private previousInstituicaoId: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private messageService: MessageService,
    private confirm: ConfirmationService
  ) {
    this.form = this.fb.group({
      estudanteID: [null],
      instituicao: ['', Validators.required],
      AnoFrequencia: [''],
      bolsaID: [''],
      estudante: [''],
      curso: [''],
      valores: [{ value: '', disabled: true }],
      valoresextenso: [''],
      moeda: [{ value: '', disabled: true }],
      numeroReferencia: [''],
      data: [new Date(), Validators.required],
      assunto: [''],
      idioma: ['pt', [Validators.required]],
    });
  }

  ngOnInit(): void {
    const anoAtual = new Date().getFullYear();
    this.AnoCurricar = Array.from({ length: 6 }, (_, i) => {
      const inicio = anoAtual + i;
      return {
        label: `${inicio}/${inicio + 1}`,
        value: `${inicio}/${inicio + 1}`,
      };
    });

    // this.getAllBolseiros();
    this.getAllInstituicoesEnsino();

    this.previousInstituicaoId = this.form.get('instituicao')?.value ?? null;

    this.form
      .get('instituicao')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((novoId) => this.handleInstituicaoChange(novoId));

    this.form
      .get('estudanteID')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.pagination = new Pagination<any>().deserialize([]);
        if (!value) return;
        this.loadAllBolsa({ BolseiroID: value });
      });

    this.form
      .get('valores')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        const numerico =
          typeof value === 'string'
            ? parseFloat(value.replace(/\./g, '').replace(',', '.'))
            : Number(value);
        if (!isNaN(numerico)) {
          this.form
            .get('valoresextenso')!
            .setValue(toExtensoComMoeda(numerico, this.form.get('moeda')?.value || ''), {
              emitEvent: false,
            });
        } else {
          this.form.get('valoresextenso')!.setValue('', { emitEvent: false });
        }
        this.emitValores();
      });

    this.form
      .get('valoresextenso')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.emitValores());

    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.emitPayload());

    this.syncDisabled();
  }

  ngOnChanges(): void {
    this.syncDisabled();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  removeEmpty(obj: any): any {
    if (Array.isArray(obj)) {
      // Filtra elementos vazios em arrays
      return obj
        .map((v) => this.removeEmpty(v))
        .filter(
          (v) =>
            !(
              v === null ||
              v === undefined ||
              v === '' ||
              (typeof v === 'object' && Object.keys(v).length === 0) ||
              (Array.isArray(v) && v.length === 0)
            )
        );
    } else if (typeof obj === 'object' && obj !== null) {
      // Filtra propriedades vazias em objetos
      return Object.fromEntries(
        Object.entries(obj)
          .map(([k, v]) => [k, this.removeEmpty(v)])
          .filter(
            ([_, v]) =>
              !(
                v === null ||
                v === undefined ||
                v === '' ||
                (typeof v === 'object' && Object.keys(v).length === 0) ||
                (Array.isArray(v) && v.length === 0)
              )
          )
      );
    }
    return obj;
  }

  // ---------- Helpers ----------

  private pickMatricula(b: any) {
    const arr = Array.isArray(b?.matricula) ? b.matricula : [];
    if (!arr.length) return null;
    const emCurso = arr.find(
      (m: any) => (m?.estadoDescricao || '').toLowerCase() === 'em curso'
    );
    if (emCurso) return emCurso;

    const parse = (d: any) => (d ? new Date(d).getTime() : 0);
    return (
      arr
        .slice()
        .sort(
          (a: any, b: any) => parse(b?.dataInicio) - parse(a?.dataInicio)
        )[0] || null
    );
  }

  private buildRegraPayload(bolsa: any): VerificarRegraPagamentoPayload {
    // tenta obter o ano curricular da matrícula atual
    const matricula = this.pickMatricula?.(bolsa);
    const anoCurricular = matricula?.anoCurricular ?? bolsa?.anoCurricular ?? 1;

    // alguns backends guardam programaFormacaoID dentro de areaProgramaFormacao
    const programaFormacaoID =
      bolsa?.programaFormacaoID ??
      bolsa?.areaProgramaFormacao?.programaFormacaoId ??
      bolsa?.areaProgramaFormacao?.programaFormacaoID ??
      0;

    // bolseiroID pode vir em bolsa.bolseiro.id ou diretamente no objeto
    const bolseiroID = Number(bolsa?.bolseiroID ?? bolsa?.bolseiro?.id ?? 0);

    return {
      id: '0',
      pedidoID: Number(bolsa?.pedidoID ?? 0),
      bolseiroID,
      requerenteID: Number(bolsa?.requerenteID ?? 0),
      isActive: Boolean(bolsa?.isActive ?? true),
      tipoBolsa: Number(bolsa?.tipoBolsa ?? 0),
      paisID: Number(bolsa?.paisID ?? 0),
      instituicaoGestoraID: Number(
        bolsa?.instituicaoGestoraID ?? bolsa?.instituicaoGestora?.id ?? 0
      ),
      nivelAcademico: Number(bolsa?.nivelAcademico ?? 0),
      areaProgramaFormacaoID: Number(
        bolsa?.areaProgramaFormacaoID ?? bolsa?.areaProgramaFormacao?.id ?? 0
      ),
      programaFormacaoID: Number(programaFormacaoID),
      anoCurricularFrequencia: String(anoCurricular),
      valorSubsidio: Number(bolsa?.valorSubsidio ?? 0),
    };
  }

  private fetchValorByRegra(bolsa: any) {
    // MONTA APENAS OS CAMPOS PERMITIDOS
    const body = this.buildRegraPayload(bolsa);
    // (opcional) validações mínimas antes de chamar a API
    if (!body) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Dados incompletos',
        detail:
          'Verifique se o estudante possui uma bolsa válida para obter o valor.',
        life: 3000,
      });
      return;
    }

    this.bolsaService
      .verificarRegraPagamento(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // 1) Se vier “valorPagamento” direto e > 0, ok.
          let valor = Number(res?.valorPagamento ?? 0);

          // 2) Caso contrário, procurar na lista a ENTRADA "Apoio a formação"
          if (!valor || isNaN(valor)) {
            const lista = Array.isArray(res?.regraPagamentoSubsidio)
              ? res.regraPagamentoSubsidio
              : [];

            // tenta por subsidioId conhecido (2) ou por descrição
            const apoioFormacao =
              lista.find((x: any) => x?.subsidioId === 2) ??
              lista.find((x: any) =>
                String(x?.subsidios?.descricao ?? '')
                  .toLowerCase()
                  .includes('apoio a formação')
              );

            valor = Number(apoioFormacao?.valor ?? 0);
            this.form.controls['moeda'].setValue(apoioFormacao?.moeda ?? '');
          }

          this.valorRegra = !isNaN(valor) && valor > 0 ? valor : null;

          if (this.valorRegra != null) {
            this.form.get('valores')?.enable({ emitEvent: false });
            // Se “valores” for input de texto, envie string formatada:
            this.form
              .get('valores')
              ?.setValue(this.formatPtBR(this.valorRegra), { emitEvent: true });
          } else {
            this.form.get('valores')?.disable({ emitEvent: false });
            this.form.get('valores')?.setValue('', { emitEvent: true });
          }
        },
        error: (err) => {
          console.error('Falha ao verificar regra de pagamento:', err);
          this.valorRegra = null;
          this.form.get('valores')?.disable({ emitEvent: false });
          this.form.get('valores')?.setValue('', { emitEvent: true });
        },
      });
  }

  private formatPtBR(n: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n || 0);
  }

  private handleInstituicaoChange(novoId: string) {
    const anterior = this.previousInstituicaoId;

    this.Estudantes = [];
    if (novoId) this.getAllBolseiros({ InstituicaoEnsinoID: novoId });

    if (!this.students.length || !anterior || anterior === novoId) {
      this.previousInstituicaoId = novoId ?? null;
      return;
    }

    this.confirm.confirm({
      header: 'Confirmar alteração',
      message:
        'Tem a certeza que pretende mudar de instituição? Os estudantes seleccionados serão desmarcados.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, mudar',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.clearStudents();
        this.previousInstituicaoId = novoId ?? null;
      },
      reject: () => {
        this.form.get('instituicao')!.setValue(anterior, { emitEvent: false });
      },
    });
  }

  private clearStudents() {
    this.students = [];
    this.form.get('estudanteID')!.setValue(null);
    this.pagination = new Pagination<any>().deserialize([]);
    this.bolsa = null;
    this.valorRegra = null;
    this.emitPayload();
    this.messageService.add({
      severity: 'info',
      summary: 'Limpo',
      detail: 'Estudantes desmarcados ao mudar de instituição.',
    });
  }

  getAllInstituicaoCurso(params: any) {
    this.instituicaoEnsinoCursoService
      .list(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.instituicaoCursoList = response.data.map((item: any) => ({
            ...item,
            id: item?.id,
            nome: item?.curso,
          }));
        },
        error: (err) =>
          console.error('Erro ao buscar instituições de curso:', err),
      });
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService
      .list({ pageSize: 100, PaisID: '193' })
      .pipe(takeUntil(this.destroy$))
      .subscribe((institutions) => {
        this.InstEnsino = institutions.data;
      });
  }

  getAllBolseiros(queryParams: any = {}) {
    this.bolseiroService
      .list({ ...queryParams, pageSize: 100, OrderBy: 'id desc' })
      .pipe(takeUntil(this.destroy$))
      .subscribe((bolseiros) => {
        this.Estudantes = bolseiros.data;
      });
  }

  loadAllBolsa(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
    };
    this.bolsaService
      .list({
        ...params,
        BolseiroID: queryParams.BolseiroID || this.bolseiroID,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.pagination = new Pagination<any>().deserialize(response);
          this.bolsa = response.data?.[0];

          this.form.get('bolsaID')?.setValue(this.bolsa?.id);
          this.form.get('estudante')?.setValue(this.bolsa?.bolseiro?.nome);

          // Pede o valor pela regra
          this.fetchValorByRegra(this.bolsa);
        },
        error: (error) => console.error('Erro ao carregar bolsa:', error),
      });
  }

  // ---------- UI actions ----------

  addStudent() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Campos obrigatórios',
        detail: 'Preencha os campos antes de adicionar.',
      });
      return;
    }

    const estudanteID = this.form.value.estudanteID;
    const estudante = this.Estudantes.find((e) => e.id === estudanteID);

    const jaAdicionado = this.students.some((s) => s.id === estudanteID);
    if (jaAdicionado) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Este estudante já foi adicionado',
        life: 3000,
      });
      return;
    }

    if (!estudante || !this.bolsa) {
      console.error('Estudante ou bolsa não encontrados!');
      return;
    }

    const matricula = this.pickMatricula(this.bolsa);
    const curso = matricula?.curso ?? '—';
    const anoCurricular = matricula?.anoCurricular ?? '—';

    this.students.push({
      id: estudanteID,
      numero: this.students.length + 1,
      nome: estudante.nome,
      curso, // da matrícula
      AnoFrequencia: anoCurricular || 0, // da matrícula
      instituicao: this.InstEnsino.find(
        (i) => i.id === this.form.get('instituicao')?.value
      )?.nome,
      bolsaID: this.bolsa.id,
      bolsaDescricao: this.bolsa.descricao,
      valor: this.form.get('valores')?.value ?? this.valorRegra ?? 0, // da regra
      valorExtenso: this.form.get('valoresextenso')?.value ?? '',
      moeda: this.form.get('moeda')?.value ?? '',
    });

    this.emitPayload();
  }

  private parsePtBRNumber(input: unknown): number {
    if (typeof input === 'number') return input;
    const s = String(input ?? '').trim();
    if (!s) return NaN;
    return Number(s.replace(/\./g, '').replace(',', '.'));
  }

  removeStudent(index: number) {
    this.students.splice(index, 1);
    this.emitPayload();
  }

  // ---------- sync/emit ----------

  private syncDisabled() {
    if (!this.form) return;
    this.disabled
      ? this.form.disable({ emitEvent: false })
      : this.form.enable({ emitEvent: false });
  }

  private emitValores() {
    const payloadParcial = {
      bolsaID: this.form.controls['bolsaID'].value,
      valores: this.form.controls['valores'].value,
      valoresextenso: this.form.controls['valoresextenso'].value,
    };
    this.formValueChanges.emit(payloadParcial);
  }

  private emitPayload() {
    const data = {
      tipoDocumento: this.documento?.tipoDocumento ?? 1,
      estadoDocumento: 0,
      utilizadorID: 'string',
      dados: {
        ...this.form.value,
        numeroReferencia: this.form.value.numeroReferencia,
        data: this.form.value.data,
        assunto: this.form.value.assunto,
        instituicaoEnsinoID: this.form.value.instituicao,
        estudantes: this.students,
        anoLectivo: this.form.value.AnoFrequencia,
        idioma: this.form.value.idioma,
      },
    };
    this.formValueChanges.emit({ data, valid: this.form.valid });
  }
}
